import { useState } from 'react'
import { Typography } from '@mui/material'
import TokTokDocDialog from '../../Common/Dialog'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import { RequesterAddIcon } from '../../../assets/icons/icons'
import useStyles from './_styles'
import useButtonStyles from '../../../styles/buttonsStyles'
import { PlannedExpertiseDraftDialogProps } from './_props'
import { RECAP_POSITION } from './workflow/constants'
import { persistCurrentQuestion } from './workflow/utils/workflowStorage'

interface DraftDialogProps extends PlannedExpertiseDraftDialogProps {
    transmissionId?: string
    committedAnswersByQuestionId: Map<string, any[]>
    localAnswersByQuestionId: Map<string, any[]>
    currentQuestionId?: string | null
    isRecap: boolean
    saveProgress: (answers: Map<string, any[]>, position: string | null) => Promise<void>
}

const PlannedExpertiseDraftDialog = ({
    isOpen,
    onClose,
    onConfirm,
    transmissionId,
    committedAnswersByQuestionId,
    localAnswersByQuestionId,
    currentQuestionId,
    isRecap,
    saveProgress,
}: DraftDialogProps) => {
    const dispatch = useAppDispatch()
    const classes = useStyles()
    const buttons = useButtonStyles()
    const [isSaving, setIsSaving] = useState(false)

    const handleSaveDraft = async () => {
        if (!transmissionId) {
            onConfirm()
            return
        }
        setIsSaving(true)
        try {
            const mergedMap = new Map(committedAnswersByQuestionId)
            const currentLocalAnswers = currentQuestionId ? localAnswersByQuestionId.get(currentQuestionId) : undefined
            if (!isRecap && currentQuestionId && currentLocalAnswers && currentLocalAnswers.length > 0) {
                mergedMap.set(currentQuestionId, currentLocalAnswers)
            }
            const position = isRecap ? RECAP_POSITION : currentQuestionId || null
            await saveProgress(mergedMap, position)
            if (position) {
                persistCurrentQuestion(transmissionId, position)
            }
            dispatch(
                displaySnackbar(
                    'success',
                    'La téléexpertise brouillon a bien été sauvegardée !',
                    undefined,
                    '[PlannedExpertiseDraftDialog] brouillon sauvegardé',
                ),
            )
            onConfirm()
        } catch (error) {
            console.error('Erreur lors de la sauvegarde du brouillon:', error)
            dispatch(
                displaySnackbar(
                    'error',
                    'Une erreur est survenue pendant la sauvegarde du brouillon',
                    undefined,
                    '[PlannedExpertiseDraftDialog] error brouillon',
                ),
            )
        } finally {
            setIsSaving(false)
            onClose()
        }
    }

    return (
        <TokTokDocDialog
            isOpen={isOpen}
            handleClose={onClose}
            handleSave={handleSaveDraft}
            handleCancel={onClose}
            saveTitle="Terminer plus tard"
            title="Êtes-vous sûr de remettre l'édition de la téléexpertise à plus tard ?"
            loading={isSaving}
            disableEscape={false}
            dialogProps={{
                fullScreen: false,
                disableScrollLock: false,
                PaperProps: {
                    className: classes.dialogPaperNoScroll,
                    style: { overflow: 'hidden' },
                },
            }}
            classNames={{
                dialogTitle: classes.helpDraftTitle,
                paper: classes.helpDialogPaper,
            }}
            buttonsOptions={{
                colors: {
                    save: '#313336',
                    cancel: undefined,
                },
            }}
        >
            <Typography className={classes.deleteText}>
                En poursuivant, toutes les données déjà saisies seront conservées : rendez-vous depuis la page des
                "téléexpertises" pour la reprendre
            </Typography>
            <RequesterAddIcon />
        </TokTokDocDialog>
    )
}

export default PlannedExpertiseDraftDialog
